var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "setting-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.117,7.769c-2.112,0-2.975-1.493-1.925-3.325a2.213,2.213,0,0,0-.817-3.022L16.357.267a1.947,1.947,0,0,0-2.66.7l-.128.222c-1.05,1.832-2.777,1.832-3.838,0L9.6.967a1.915,1.915,0,0,0-2.637-.7L4.947,1.422A2.226,2.226,0,0,0,4.13,4.455c1.062,1.82.2,3.313-1.913,3.313A2.223,2.223,0,0,0,0,9.985v2.053a2.223,2.223,0,0,0,2.217,2.217c2.112,0,2.975,1.493,1.913,3.325A2.213,2.213,0,0,0,4.947,20.6l2.018,1.155a1.947,1.947,0,0,0,2.66-.7l.128-.222C10.8,19,12.53,19,13.592,20.835l.128.222a1.947,1.947,0,0,0,2.66.7L18.4,20.6a2.216,2.216,0,0,0,.817-3.022c-1.062-1.832-.2-3.325,1.913-3.325a2.223,2.223,0,0,0,2.217-2.217V9.985A2.241,2.241,0,0,0,21.117,7.769ZM11.667,14.8a3.792,3.792,0,1,1,3.792-3.792A3.8,3.8,0,0,1,11.667,14.8Z",
    transform: "translate(2.333 2.988)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.62bf8bf57d6e16cd7e385b885ef757eb.svg";
export { ForwardRef as ReactComponent };